import { Component, OnInit } from "@angular/core";
import { Appsettings } from "../../../../configuration/appsettings";
import { Router } from "@angular/router";

// SERVICES
import {
  StorageService,
  UserService,
  SettingsService,
} from "../../../../service/service.index";

// COMPONENT SERVICES
import { AdminHeaderService } from "./admin-header.service";
import { AdminNavService } from "../admin-nav/admin-nav.service";

import swal from "sweetalert2";
import { DialogDetailsNotification } from "src/app/dialogs/dialog-details-notification/dialog-details-notification.component";
import { MatDialog } from "@angular/material";
//import { AngularFireMessaging } from '@angular/fire/messaging';

declare var dataLayer;
@Component({
  selector: "app-admin-header",
  templateUrl: "./admin-header.component.html",
  styleUrls: ["./admin-header.component.scss"],
})
export class AdminHeaderComponent implements OnInit {
  nameUser: string;
  profileImage: string;
  email: string;
  working: boolean;

  constructor(
    public _srvStorage: StorageService,
    private _srvUser: UserService,
    public _srvAdminNav: AdminNavService,
    //private afMessaging: AngularFireMessaging,
    public _srvHeaderNav: AdminHeaderService,
    public _srveSettings: SettingsService,
    private router: Router,
    public dialog: MatDialog
  ) {
    const profileImg =
      _srvStorage.profileImage != null
        ? _srvStorage.profileImage
        : "assets/img/profileimg/profile-placeholder.png";

    this.profileImage = profileImg;
    this.email = _srvStorage.email;
    this._srvAdminNav.notifications = [];

    if (this._srvStorage.loggedIn) {
      /*this.afMessaging.requestToken.subscribe(
        token => {
          if ( this._srvStorage.tokenMessage !== token ) {
            this._srvUser.updateDevice(token).subscribe( res => {
              this._srvStorage.tokenMessage = token;
            });
          }
        },
        error => {
        }
      );

    this.afMessaging.messages.subscribe(message => {


      const messageData = message['data'];
        let notification;
        const optionsNotification = {
          body: `${message['notification'].title} ${messageData['gcm.notification.text']}`,
        };

      if (!('Notification' in window)) {
          console.log( 'This browser does not support desktop notification' );
        } else if ( Notification.prototype.permission === 'granted' ) {
          notification = new Notification( Appsettings.APP_NAME, optionsNotification);
          notification.onclick = function() {
            this.close();
            };
        } else if ( Notification.prototype.permission !== 'denied') {
          Notification.requestPermission(function (permission) {
            if (permission === 'granted') {
                notification = new Notification( Appsettings.APP_NAME , optionsNotification);
              notification.onclick = function() {
                this.close();
              };
            }
          });
        }
      });*/
    }
  }

  updateImageProfile() {
    this.profileImage = this._srvStorage.profileImage;
  }

  ngOnInit() {
    this.nameUser = this._srvStorage.name;
    this._srvAdminNav.setNotifications();
  }

  // Permite cerrar sesión del sistema y eliminar los daltos locales
  signOut() {
    let module;
    switch (this.router.url) {
      case "/resource/content/20":
        module = "Inglés LTE";
        break;
      case "/resource/home":
        module = "Inicio";
        break;
      case "/resource/content/0":
        module = "Guías del maestro y recusos digitales";
        break;
      case "/resource/libros-texto/18":
        module = "Libros de texto en pdf";
        break;
      case "/resource/libros-texto-digital/19":
        module = "Libros de textos descargables";
        break;
      case "/resource/academic-manager":
        module = "Documentos de gestión académica";
        break;
      case "/resource/content/16":
        module = "Sereie de inglés - help";
        break;
      case "/resource/services/servicios_pedagogicos":
        module = "Catálogos de servicios pedagógicos";
        break;
      case "/resource/services/sitios_de_interes":
        module = "Sitios de interés recomendados";
        break;
      case "/resource/services/software_gratuito":
        module = "Aplicaciones recomendadas";
        break;
      case "/admin/list-exam":
        module = "Generador de exámenes";
        break;
      case "/admin/question-bank/0/2":
        module = "Generador de evaluaciones del plan lector";
        break;
      case "/admin/list-question-bank":
        module = "Generador de reactivos para exámenes";
        break;
      case "/ra/list-announcement":
        module = "Generador de avisos";
        break;
      case "/teacher/courses":
        module = "Generador de cursos";
        break;
      case "/ra/repository":
        module = "Contenedor de documentos";
        break;
      case "/ra/forum":
        module = "Generador de foros";
        break;
      case "/resource/privacy":
        module = "Aviso de privacidad";
        break;
      case "/resource/frequent-questions":
        module = "Ayuda - preguntas frecuentes";
        break;

      default:
        module = "Otro";
        break;
    }
    swal({
      title: "Cerrar sesión",
      text: "¿Realmente deseas salir de la aplicación?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Cerrar ahora",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.working = true;
        this._srvUser.logOut().subscribe(
          (res) => {
            dataLayer.push(function () {
              this.reset();
            });
            dataLayer.push({
              event: "ev_log_out",
              category: "log_out",
              action: module,
            });
            if (this._srvStorage.tokenMessage) {
              //this.afMessaging.deleteToken(this._srvStorage.tokenMessage);
            }
            this._srvStorage.logoutRedirect();
            this._srveSettings.applyDefaultTheme();
          },
          (error) => {
            this._srvStorage.logoutRedirect();
            this._srveSettings.applyDefaultTheme();
          }
        );
      }
    });
  }

  onClickShow(tittle: string, body: string) {
    const DIALOG_REF = this.dialog.open(DialogDetailsNotification, {
      width: "500px",
      height: "600px",
      autoFocus: false,
      disableClose: true,
      data: { tittle: tittle, body: body },
    });

    DIALOG_REF.afterClosed().subscribe((response) => {});
  }

  onReadMessages(id: number) {
    this._srvUser.readNotification(id).subscribe((res) => {
      if (res.success) {
        this._srvStorage.notifications = JSON.stringify(
          this._srvAdminNav.notifications.filter((x) => x.id !== id)
        );
        this.getNotifications();
      }
    });
  }

  getNotifications() {
    this._srvAdminNav.setNotifications();
  }
}
